<div class="inner-table">
  <table>
    @for (row of group.loaded; track row.id) {
      @if (!row.deleted && row.fields.length && !row.hidden) {
        @if (headers.length && $index === 0 && options.head) {
          <tr class="header-row">
            @for (header of headers; track $index) {
              @if (header.visible && header.options.list) {
                <th class="field-header" [class]="header.pfx" [style.width]="header.options.width" [ngClass]="header.sort && 'sortable'" (click)="sort.emit(header)">
                  <div class="table-head-inner">
                    @if (header.options.icon && header.visible) {
                      <div class="icon-container">
                        @let icon = '<i class="' + header.options.icon + '"></i>';
                        <span [innerHTML]="icon | iconReplace"></span>
                      </div>
                    }
                    <span [title]="header.label" [innerText]="header.label"></span>
                    @if (header.sort) {
                      <span class="sort-icon">
                        <mat-icon>
                          @switch (header.sort.direction) {
                            @case ("DESC") {
                              expand_more
                            }
                            @case ("ASC") {
                              expand_less
                            }
                            @case ("INITIAL") {
                              unfold_more
                            }
                          }
                        </mat-icon>
                      </span>
                    }
                  </div>
                </th>
              }
            }
            @if (options.selectable) {
              <th style="width: 32px">
                @let selected = group.getSelected().length;
                <mat-checkbox
                  [checked]="selected === group.rows.length"
                  [indeterminate]="selected > 0 && selected !== group.rows.length"
                  [aria-label]="'TABLE.TH.CHECKALL' | translate"
                  (change)="group.selectAll($event.checked); rowSelection.emit()"
                />
              </th>
            }
          </tr>
        }

        <tr class="data-row" [ngClass]="{ highlight: row.highlighted }">
          @for (field of row.fields; track $index) {
            @let header = headers[$index];
            @if (header.visible && field.header.options.list) {
              <td [ngClass]="{ hidden: field.hidden }">
                <div class="field" (click)="log(field)">
                  <app-table-prefix [field]="field" [tooltip]="field.tooltip" (prefixevent)="prefixEvent.emit([$event, row])" />
                </div>
              </td>
            }
          }
          @if (options.selectable) {
            <td>
              <mat-checkbox [aria-label]="'TABLE.TD.CHECKSINGLE' | translate" [checked]="row.selected" (change)="row.select($event.checked); rowSelection.emit()" />
            </td>
          }
        </tr>
      }
    }
    @for (subgroup of group.groups; track $index) {
      @let amount = subgroup | tableGroupAmount: "loaded";
      @if (amount.visible > 0) {
        <mat-expansion-panel class="group" hideToggle [expanded]="!subgroup.collapsed" [ngClass]="{ hidden: subgroup.hidden }" (expandedChange)="subgroup.collapsed = !$event">
          <mat-expansion-panel-header class="group-header">
            <span class="icon">
              <mat-icon>expand_more</mat-icon>
            </span>
            <span #groupHeader>
              @if (subgroup.fieldname) {
                <b><span [innerHTML]="subgroup.fieldname"></span>: </b>
              }
              <span [innerHTML]="subgroup.label"></span>
            </span>
          </mat-expansion-panel-header>

          <table>
            <app-table-list-view-group
              [group]="subgroup"
              [headers]="headers"
              [options]="options"
              (rowSelection)="rowSelection.emit()"
              (prefixEvent)="prefixEvent.emit($event)"
              (sort)="sort.emit($event)"
            />
          </table>
        </mat-expansion-panel>
      }
    }
  </table>
</div>
